module.exports = Symbol.hasInstance
